import axios from 'axios';

export const postSwrFetcher = async <T, R>(url: string, { arg }: { arg: T }) => {
  const response = await axios.post<R>(url, arg);

  return response.data;
};
